<template>
  <div class="hub-activity-rows">
    <template v-for="(item, index) in entries">
      <h4 v-if="groupDates && (index === 0 || entries[index - 1].date !== item.date)" :key="item.id + ':date'" class="hub-activity-day">{{ $moment(item.date).format('ddd, D. MMMM') }}</h4>
      <button :key="item.id" type="button" class="hub-activity-row" :class="{ 'hub-activity-row--pending': item.pendingOverlap }" @click="$emit('select', item, $event)">
        <CustomerHubActivitySymbol class="hub-activity-symbol" :activity="item" />
        <span class="hub-activity-copy"><strong>{{ item.title }}</strong><span class="hub-activity-meta">{{ dateLabel(item) }}</span>
          <small v-if="item.pendingOverlap" class="hub-overlap-note">Zuordnung prüfen</small>
          <small v-else-if="showStatus && item.status !== 'completed'">{{ statusLabel(item.status) }}</small>
        </span>
        <span class="hub-activity-end"><strong>{{ shortDuration(item.durationSeconds) }}</strong><small v-if="item.sources.length > 1" :title="item.sourceNames.join(' + ')"><v-icon size="12">mdi-link-variant</v-icon> Verbunden</small><small v-else-if="item.durationSource === 'course_schedule'">laut Kursplan</small></span>
        <v-icon class="hub-activity-chevron" size="18">mdi-chevron-right</v-icon>
      </button>
    </template>
  </div>
</template>
<script>
import { hubStatusLabel } from "@/services/customerHubActivityData"
import CustomerHubActivitySymbol from "./CustomerHubActivitySymbol.vue"
export default {
  components: { CustomerHubActivitySymbol },
  props: { entries: { type: Array, default: () => [] }, showDate: Boolean, groupDates: Boolean, showStatus: { type: Boolean, default: true } },
  methods: {
    statusLabel: hubStatusLabel,
    shortDuration(seconds) {
      if (seconds === null || seconds === undefined || !Number.isFinite(Number(seconds))) return "–"
      const minutes = Math.floor(Number(seconds) / 60)
      return minutes >= 60 ? Math.floor(minutes / 60) + " h " + String(minutes % 60).padStart(2, "0") : minutes ? minutes + " min" : seconds > 0 ? "< 1 min" : "0 min"
    },
    dateLabel(item) {
      const day = this.showDate && !this.groupDates ? this.$moment(item.date).format("DD.MM.") : ""
      const time = (item.timeIsExact || item.scheduledTimeIsExact) && item.startedAt ? this.$moment(item.startedAt).format("HH:mm") : ""
      return [day, time, item.sourceNames.join(" + ")].filter(Boolean).join(" · ")
    },
  },
}
</script>
<style scoped>
.hub-activity-rows { display: grid; gap: 8px; min-width: 0; }
.hub-activity-day { margin: 16px 2px 2px; font-size: 12px; font-weight: 500; color: #aaa; line-height: 1.4; }.hub-activity-day:first-child { margin-top: 0; }
.hub-activity-row { width: 100%; display: flex; align-items: center; gap: 11px; padding: 15px 12px; border: 1px solid #ffffff09; border-radius: 17px; background: #292929; color: #f5f5f5; text-align: left; word-break: normal; transition: background .15s ease; }
.hub-activity-row:hover { background: #303030; }.hub-activity-row:active { background: #353535; }
.hub-activity-copy { flex: 1; min-width: 0; }
.hub-activity-copy > strong, .hub-activity-copy > small { display: block; line-height: 1.35; overflow-wrap: break-word; word-break: normal; }
.hub-activity-copy > strong { font-size: 15px; font-weight: 650; }
.hub-activity-meta { display: block; margin-top: 5px; font-size: 11px; color: #aaa; line-height: 1.5; overflow-wrap: break-word; }
.hub-activity-copy > small { font-size: 11px; color: #bbb; margin-top: 5px; }.hub-activity-copy .hub-overlap-note { color: #dbb876; }
.hub-activity-end { flex: 0 0 auto; text-align: right; max-width: 90px; }
.hub-activity-end > strong { font-size: 13px; font-weight: 600; white-space: nowrap; font-variant-numeric: tabular-nums; }
.hub-activity-end > small { display: flex; align-items: center; justify-content: flex-end; gap: 3px; margin-top: 6px; font-size: 9px; color: #a6b7ae; }.hub-activity-end .v-icon { color: inherit; }
.hub-activity-chevron { color: #777; flex: 0 0 auto; }.hub-activity-row--pending { border-color: #dbb87625; }
button:focus-visible { outline: 2px solid var(--v-primary-base, #00963f); outline-offset: 3px; }
@media(max-width: 359px) { .hub-activity-row { gap: 8px; padding: 13px 10px; }.hub-activity-chevron { display: none; } }
@media(prefers-reduced-motion: reduce) { .hub-activity-row { transition: none; } }
</style>
